import { render, staticRenderFns } from "./whoisSearch.vue?vue&type=template&id=04443f1c&scoped=true&"
import script from "./whoisSearch.vue?vue&type=script&lang=js&"
export * from "./whoisSearch.vue?vue&type=script&lang=js&"
import style0 from "./whoisSearch.vue?vue&type=style&index=0&id=04443f1c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04443f1c",
  null
  
)

export default component.exports